// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__tz3oo","formControl":"addForm_formControl__F+ens","list":"addForm_list__eZNFA","btnWrpper":"addForm_btnWrpper__Xo--X"};